import { Primary, PrimaryDark } from './Palettes/index.js';
export { CHART_COLOR_KEYS, chartColor } from './chartColors.js';
export const palette = {
    primary: Primary,
    primaryDark: PrimaryDark,
};
